import { Box, Button, Divider, Flex, Image, Text, useToast, VStack } from '@chakra-ui/react';
import { FormikInput } from '../../components/common/Form/FormikInput';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import { useCallback } from 'react';
import Joi from 'joi';
import { getErrors } from '../../services/Joi/JoiValidationService';
import { login } from '../../services/Admin/AuthService';

export interface AdminLoginViewProps {
  handleLoadingSpinner: (value: boolean) => void;
  handleTokenState: (token: string) => void;
}

export const AdminLoginView = (props: AdminLoginViewProps): JSX.Element => {
  const { handleLoadingSpinner, handleTokenState } = props;
  const toast = useToast();

  useEffect(() => {
    handleLoadingSpinner(false);
  }, []);

  const getLoginParamsFormValidationSchema = (): Joi.AnySchema => {
    return Joi.object().keys({
      Password: Joi.string().pattern(new RegExp('^[a-zA-Z0-9]{5,30}$')).required().messages({
        'string.empty': 'Bitte geben Sie Ihr Passwort an.',
        'any.required': 'Bitte geben Sie Ihr Passwort an.',
        'string.pattern.base': 'Passwort muss mindestens 5 Zeichen lang sein.',
      }),
      Username: Joi.string().required().messages({
        'string.empty': 'Bitte geben Sie ihren Benutzernamen an.',
        'any.required': 'Bitte geben Sie Ihren Benutzernamen an.',
      }),
    });
  };

  type loginValues = { Username: string; Password: string };

  const formik = useFormik({
    validateOnChange: false,
    initialValues: { Username: '', Password: '' } as loginValues,
    onSubmit: values => {
      handleSubmit(values);
    },
    validate: (values: loginValues) => {
      return getErrors(getLoginParamsFormValidationSchema(), values);
    },
  });

  const handleSubmit = useCallback(async values => {
    handleLoadingSpinner(true);
    const ADMIN_DETAILS = 'ADMIN_DETAILS';
    const loginParams = {
      username: values.Username,
      password: values.Password,
      ttltoken: 10000,
    };
    try {
      const loginDetails = await login(loginParams);
      const serializedState = JSON.stringify(loginDetails.data);
      sessionStorage.setItem(ADMIN_DETAILS, serializedState);
      handleTokenState(loginDetails.data?.alpdesk_token);
    } catch (e) {
      if (e?.response) {
        handleLoadingSpinner(false);
        toast({
          position: 'top-right',
          title: 'Email oder Passwort ist falsch.',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      }
    }
    handleLoadingSpinner(false);
  }, []);

  return (
    <Box maxWidth={450} m={'0 auto'} pt={'80px'}>
      <VStack
        as={'form'}
        // @ts-ignore
        onSubmit={formik.handleSubmit}
        bgColor={'white'}
        alignItems={'center'}
        justifyContent={'center'}
        gridGap={4}
        mt={'35px'}
        p={{ base: 8, sm: 4 }}
        borderRadius={4}
        boxShadow="xs">
        <VStack width={'100%'} gridGap={4} alignItems={'baseline'}>
          <VStack width={'100%'}>
            <Image
              w={48}
              flex={1}
              src={
                'https://www.fewo-traumreisen.de/files/theme/img/logos/logo-fewo-traumreisen_ohne-claim.svg'
              }
            />
            <Text
              flex={1}
              textAlign={'left'}
              fontSize={{ base: 'lg' }}
              fontWeight={'semibold'}
              color={'gray.600'}>
              Eigentümerverwaltung
            </Text>
          </VStack>

          <Divider />
          <Flex flex={1} w={'100%'}>
            <FormikInput label={'Benutzer'} name={'Username'} formik={formik} type={'text'} />
          </Flex>

          <Flex flex={1} w={'100%'}>
            <FormikInput label={'Passwort'} name={'Password'} formik={formik} type={'password'} />
          </Flex>
        </VStack>
        <Divider />

        <Button variant="primary" type={'submit'} colorScheme={'blue'} w={'100%'}>
          Anmelden
        </Button>
      </VStack>
    </Box>
  );
};
